import { render, staticRenderFns } from "./CreateOtherSupplierUserPopUp.vue?vue&type=template&id=54d13270&"
import script from "./CreateOtherSupplierUserPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOtherSupplierUserPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports